const PORTAL_LOGIN_TARGET = /^\/login(?:[/?#]|$)/
const ALLOWED_TARGETS = ['/admin/', '/vakt/']

export function normalizeNextPath(value?: string): string | null {
  if (!value) return null

  let path = value.trim()
  if (!path) return null

  try {
    const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost'
    const parsed = new URL(path, origin)
    if (parsed.origin !== origin) return null
    path = `${parsed.pathname}${parsed.search}${parsed.hash}`
  } catch {
    return null
  }

  if (!path.startsWith('/') || path.startsWith('//')) return null
  if (path === '/' || PORTAL_LOGIN_TARGET.test(path)) return null

  return ALLOWED_TARGETS.some((target) => path === target.slice(0, -1) || path.startsWith(target))
    ? path
    : null
}

export function targetForPath(path: string | null): 'admin' | 'vakt' | null {
  if (!path) return null
  if (path === '/admin' || path.startsWith('/admin/')) return 'admin'
  if (path === '/vakt' || path.startsWith('/vakt/')) return 'vakt'
  return null
}
